import { Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./DocumentInput.module.css";
import upload_icon from "assets/images/upload_icon.svg";
import { useDropzone } from "react-dropzone";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import { cutText, extractDocType } from "utils/helpers";

function DocumentInput({ image, setImage, fileError, setFileError }) {
  useEffect(() => {
    setImage(null);
    setFileError(null);
  }, []);

  const onDrop = useCallback((acceptedFiles) => {
    setFileError(null);
    const file = acceptedFiles[0];

    if (!!file) {
      if (file?.size > 25 * 1000 * 1000) {
        setImage(null);
        setFileError("File size must not be greater than 25mb");
      } else if (
        file.type === "image/png" ||
        file?.type === "application/pdf" ||
        file?.type === "application/csv" ||
        file?.type === "image/jpeg" ||
        file?.type === "image/jpg" ||
        file?.type === "image/tiff"
      ) {
        setImage(file);
      } else {
        setImage(null);
        setFileError("Document must be either PDF, CSV or image files");
      }
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive, fileRejections } =
    useDropzone({
      onDrop,
      maxFiles: 1,
    });

  return (
    <div className={styles.document_input}>
      <div className={styles.label}>
        <Typography>Attach Documents</Typography>
      </div>

      <div className={styles.input_box} {...getRootProps()}>
        {!!image ? (
          <>
            {image?.name.length > 15 ? (
              <p className={styles?.image_name}>
                {cutText(image?.name, 10, "start")}...
                {extractDocType(image?.name)}
              </p>
            ) : (
              <p>
    {image?.name}
              </p>
          
            )}
          </>
        ) : (
          <div className={styles.input_field}>
            <img src={upload_icon} alt="" />
            <Typography>Drag and Drop here</Typography>
            <Typography>or</Typography>
            <Typography variant="h6">Browse files</Typography>
            <input
              {...getInputProps()}
              accept="application/pdf, application/csv, image/*"
            />
          </div>
        )}
      </div>
      <div className={styles.nb}>
        <p>
          <strong>NB:</strong> Only PDF, CSV or images (PNG, JFIF, JPEG, JPG)
          are accepted. Maximum File Size 25MB
        </p>
      </div>

      <ValidationMessage
        message={fileRejections[0]?.errors[0]?.message || fileError}
      />

      {/* {fileRejections[0].errors[0]?.message} */}
    </div>
  );
}

export default DocumentInput;